const googleauth = {
    state: {
        status: false
    },
    mutations: {
        GOOGLEAUTH_UPDATE_STATUS(state, { status }) {
            state.status = status
        }
    },

    actions: {
        googleauthUpdateStatus({ commit }, { status }) {
            commit('GOOGLEAUTH_UPDATE_STATUS', { status })
        }
    }
}
export default googleauth
